import { useState, useCallback } from 'react'
import * as Api from 'apps/fleet-planner/utils/api'
import { ITodo } from '../types'

interface IUseTodoApiState {
  error?: string
  todos: ITodo[]
  isLoading: boolean
  getTodos: () => Promise<ITodo[] | undefined>
  findTodoByExternalId: (externalId: string) => ITodo | undefined
}

export const useTodosApi = (): IUseTodoApiState => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [todos, setTodos] = useState<ITodo[]>([])
  const [error, setError] = useState<string>('')

  const findTodoByExternalId = useCallback(
    (externalId: string): ITodo | undefined => {
      const formattedId = externalId.split('-')[1]
      return todos.find(todo => todo.externalId === Number(formattedId))
    },
    [todos]
  )

  const getTodos = useCallback(async (): Promise<ITodo[] | undefined> => {
    setError('')
    setIsLoading(true)
    try {
      const { todos: todoList = [] } = (await Api.fetchTodos()) || {}
      setTodos(todoList)
      setIsLoading(false)
      return todoList
    } catch (e) {
      setError(e)
      setIsLoading(false)
      return undefined
    }
  }, [])

  return {
    error,
    todos,
    isLoading,
    getTodos,
    findTodoByExternalId,
  }
}
